<template>
  <main class="dark:bg-[#171915]">
    <RouterView />
  </main>
</template>
